export default {
  name: 'MainHeading',
  props: [
    'title',
    'subtitle'
  ]
}